module.exports = __webpack_public_path__ + "img/5.9f514f1b.jpg";